import { useEffect, useMemo, useRef, useState } from "react";
import { ChevronDown, Search, X } from "lucide-react";

export function SearchSelect({ options, value, onChange, placeholder = "Ketik untuk mencari...", testId, disabled, required }) {
  const [open, setOpen] = useState(false), [q, setQ] = useState(""), box = useRef(null);
  const selected = options.find((o) => o.value === value);
  const filtered = useMemo(() => {
    const words = q.toLowerCase().split(/\s+/).filter(Boolean);
    return options.filter((o) => words.every((w) => `${o.label} ${o.hint || ""}`.toLowerCase().includes(w))).slice(0, 60);
  }, [options, q]);
  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close); return () => document.removeEventListener("mousedown", close);
  }, []);
  const pick = (o) => { onChange(o.value); setOpen(false); setQ(""); };
  return <div className={`search-select${disabled ? " disabled" : ""}`} ref={box} data-testid={testId}>
    <button type="button" data-testid={testId ? `${testId}-toggle` : undefined} className={`search-select-control${selected ? "" : " placeholder"}`} disabled={disabled} onClick={() => setOpen(!open)}>
      <span className="search-select-label">{selected ? <><b>{selected.label}</b>{selected.hint && <small>{selected.hint}</small>}</> : placeholder}</span>
      {selected && !disabled ? <X size={14} className="search-select-clear" onClick={(e) => { e.stopPropagation(); onChange(""); }} /> : <ChevronDown size={15} />}
    </button>
    {required && <input tabIndex={-1} className="search-select-required" required value={value || ""} onChange={() => {}} />}
    {open && <div className="search-select-menu">
      <div className="search-box"><Search size={14} /><input autoFocus data-testid={testId ? `${testId}-search` : undefined} placeholder="Ketik beberapa kata..." value={q} onChange={(e) => setQ(e.target.value)} /></div>
      <div className="search-select-list">
        {filtered.length ? filtered.map((o) => <button type="button" key={o.value} data-testid={testId ? `${testId}-option-${o.value}` : undefined} className={o.value === value ? "active" : ""} onClick={() => pick(o)}><b>{o.label}</b>{o.hint && <small>{o.hint}</small>}{o.extra && <span className="option-extra">{o.extra}</span>}</button>) : <div className="empty">Tidak ada yang cocok</div>}
      </div>
    </div>}
  </div>;
}
